import Ajax from '../ajax';

export default {
  list: (data) => Ajax('get', 'scheduledmessage', data),
  get: (id) => Ajax('get', `scheduledmessage/${id}`),
  add: (data) => Ajax('post', 'scheduledmessage', data),
  edit: (id, data) => Ajax('put', `scheduledmessage/${id}`, data),
  delete: (id) => Ajax('delete', `scheduledmessage/${id}`),
  export: (id) => Ajax('get', `scheduledmessage/${id}/export`),
};
